import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: 'about'
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: '/events',
      name: 'events',
      component: () => import('./views/Events.vue')
    },
    {
      path: '/video',
      name: 'video-page',
      component: () => import('./views/VideoPage.vue')
    },
    {
      path: '/press',
      name: 'press',
      component: () => import('./views/Press.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('./views/News.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/ContactPage.vue')
    }
  ]
})
